import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of as observableOf } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { Currency } from '@rx-applications/shared/data-access';
import { UtilsBackend } from '@rx-applications/clientsite/shared/utils-backend-service';
import { CurrencyFacade } from './currency.facade';
import * as currencyActions from './currency.actions';

@Injectable()
export class CurrencyEffects {
  constructor(private actions$: Actions, private utilsBackend: UtilsBackend, private currencyFacade: CurrencyFacade) {}

  loadCurrencyList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(currencyActions.loadCurrencyList),
      switchMap(() => this.currencyFacade.currenciesListLoaded$),
      filter((isLoadedAlready) => !isLoadedAlready),
      switchMap(() => {
        return this.utilsBackend.getCurrencies().pipe(
          map((response: Currency[]) => {
            const currencies = response.map((currency) =>
              currency.code === 'CAD'
                ? {
                    ...currency,
                    symbol: 'CAD$',
                    htmlSymbol: 'CAD$',
                  }
                : currency
            );
            return currencyActions.loadCurrencyListSucceed({ payload: currencies });
          }),
          catchError(() => observableOf(currencyActions.loadCurrencyListFailed()))
        );
      })
    )
  );
}
